require('slick-carousel')
import has from 'lodash/has'
import qs from 'query-string'


  const $slider = $('.advantages-slider .advantages-grid__slider')

  const handleActiveGridItem = (index = 1) => {
    $('.advantages-grid button.grid-item--active').removeClass('grid-item--active')
    $(`.advantages-grid button[data-index=${index}]`).addClass('grid-item--active')
  }

  const urlParams = qs.parse(window.location.search)

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
    }
    return(false);
  }

  var startIndex

  if(window.location.href.indexOf("advantage") > -1) {
    var advantageNumber = getQueryVariable("advantage");
    startIndex = advantageNumber

    $(window).on('load', function() {
      var scrollTopDifference;

      function getHeaderHeight() {
          if ($(window).width() > 1023.9) {
              scrollTopDifference = 131;
          } else {
              scrollTopDifference = headerHeight;
          }
      }
      getHeaderHeight();
      var $location = $('.panel-advantages');

      $('html,body').animate({
          scrollTop: $location.offset().top - scrollTopDifference
      }, 'slow');
    });
  } else {
    startIndex = has(urlParams, 'start') ? urlParams.start : 1
  }

  

  handleActiveGridItem(startIndex)

  const setupSlider = () => {

    $slider.slick({
      dots: true,
      mobileFirst: true,
      initialSlide: parseInt(startIndex - 1),
      responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: false
          }
        }
      ],
    })

    $slider.on('beforeChange', (e, slick, current, next) => {
      handleActiveGridItem(next + 1)
    })

    $('.advantages-grid').on('click', 'button', e => {
      const index = $(e.currentTarget).data('index')
      $slider.slick('slickGoTo', index - 1)
      handleActiveGridItem(index)
    })
  }

  setupSlider()

  
